import React from 'react'
import CMS from '../../components/cms/CMS'

const SupportPage = () => {
    return (
        <CMS>
            
        </CMS>
    )
}

export default SupportPage
